import React, { useState, memo } from 'react';
import { ChevronDown as ChevronDownIcon, ChevronUp as ChevronUpIcon } from 'lucide-react';
const FAQItem = memo(({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-51">
      <button className="flex justify-between items-center w-full text-left font-medium text-gray-800 focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-52">
        <span className="text-lg" data-id="element-53">{question}</span>
        {isOpen ? <ChevronUpIcon className="flex-shrink-0 text-custom-brown" size={20} data-id="element-54" /> : <ChevronDownIcon className="flex-shrink-0 text-custom-brown" size={20} data-id="element-55" />}
      </button>
      {isOpen && <div className="mt-2 text-gray-600" data-id="element-56">
          <p data-id="element-57">{answer}</p>
        </div>}
    </div>;
});
const FAQ = () => {
  const faqs = [{
    question: '¿Es solo para expertos en cocina?',
    answer: 'No, el ebook está diseñado tanto para principiantes como para personas con experiencia. Las recetas tienen instrucciones paso a paso muy claras y fotos que te guían en todo el proceso.'
  }, {
    question: '¿En qué dispositivos lo puedo usar?',
    answer: 'Puedes usar el ebook en cualquier dispositivo: celular, tablet o computadora. Viene en formato PDF optimizado para todos los tamaños de pantalla.'
  }, {
    question: '¿Realmente puedo cocinar en 30 minutos?',
    answer: '¡Sí! Todas las recetas están probadas y cronometradas para completarse en 30 minutos o menos, especialmente si sigues el método de batch cooking que te enseñamos.'
  }, {
    question: '¿Incluye lista de compras?',
    answer: 'Sí, incluye una lista de compras optimizada para gastar menos y aprovechar todos los ingredientes. Está organizada por sección del supermercado para ahorrar tiempo.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tienes 7 días de garantía de devolución total. Si no estás satisfecho, simplemente envíanos un correo y te reembolsaremos el 100% de tu compra sin hacer preguntas.'
  }];
  return <section className="py-16 bg-white" data-id="element-58">
      <div className="container mx-auto px-4" data-id="element-59">
        <div className="max-w-3xl mx-auto" data-id="element-60">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800" data-id="element-61">
            Preguntas Frecuentes
          </h2>
          <div className="bg-gray-50 rounded-lg p-6" data-id="element-62">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-63" />)}
          </div>
        </div>
      </div>
    </section>;
};
export default FAQ;